import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { LicensesService } from 'src/app/services/licenses.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  fetchingCloseToExpiration = false;
  hasCloseToExpiration = false;

  constructor(
    private licensesService: LicensesService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (!this.authService.currentUser) {
      this.hasCloseToExpiration = false;
      return;
    }

    this.fetchingCloseToExpiration = true;
    this.licensesService
      .hasCloseToExpirationLicenses(this.authService.currentUser?.tenant_id)
      .subscribe({
        next: (hasCloseToExpiration) => {
          this.hasCloseToExpiration = hasCloseToExpiration;
          this.fetchingCloseToExpiration = false;
        },
        error: (error) => {
          console.error(error);
          this.hasCloseToExpiration = false;
          this.fetchingCloseToExpiration = false;
        },
      });
  }

  get hasApiSubscription() {
    return this.authService.hasApiSubscription;
  }
}
